import Wishlist from '../wishlist';
import { initRadioOptions } from './aria';
import { debounce, isObject, isNumber } from 'lodash';

const optionsTypesMap = {
    INPUT_FILE: 'input-file',
    INPUT_TEXT: 'input-text',
    INPUT_NUMBER: 'input-number',
    INPUT_CHECKBOX: 'input-checkbox',
    TEXTAREA: 'textarea',
    DATE: 'date',
    SET_SELECT: 'set-select',
    SET_RECTANGLE: 'set-rectangle',
    SET_RADIO: 'set-radio',
    SWATCH: 'swatch',
    PRODUCT_LIST: 'product-list',
};

export function optionChangeDecorator(areDefaultOtionsSet) {
    return (err, response) => {
        const attributesData = response.data || {};
        const attributesContent = response.content || {};

        this.updateProductAttributes(attributesData);
        if (areDefaultOtionsSet) {
            this.updateView(attributesData, attributesContent);
        } else {
            this.updateDefaultAttributesForOOS(attributesData);
        }
    };
}

export default class ProductDetailsBase {
    constructor($scope, context) {
        this.$scope = $scope;
        this.context = context;
        this.initRadioAttributes();
        Wishlist.load(this.context);
        this.getTabRequests();
        this.mobileDetailTab();
        this.descAnchor();
        this.scrollToAnchor();
        this.stickyFooterAddToCart();
        this.thumbSlide();
        this.productCarousel();

        $('[data-product-attribute]').each((__, value) => {
            const type = value.getAttribute('data-product-attribute');

            this._makeProductVariantAccessible(value, type);
        });

        // add vimeo video script for quickview
        $(document).ready(function() {
            if ($('body').hasClass('page-type-product')) {
                $('.productView-thumbnail a img[title*="vimeo"]', this.$scope).before('<div class="prod-image-thumb-overlay"></div>');
                $('.productView-thumbnail a img[title*="vimeo"]', this.$scope).parent().addClass('vimeo-video');
                $('.productView-thumbnail a.vimeo-video', this.$scope).click(function() {
                    var vimeoId = $(this).find('img[title*="vimeo"]').attr("title").split("/").pop();
                    $('.productView-images .prod-video-container-wrap', this.$scope).remove();
                    $('.productView-image', this.$scope).css('display', 'none');
                    $('.productView-image', this.$scope).before('<div class="prod-video-container-wrap"><div class="prod-video-container"><iframe src=https://player.vimeo.com/video/' + vimeoId + ' frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe></div></div>');
                });
                $('.productView-thumbnail a:not(.vimeo-video)', this.$scope).click(function() {
                    $('.productView-images .prod-video-container-wrap', this.$scope).remove();
                    $('.productView-image', this.$scope).css('display', 'block');
                });
            }
        });
    }

    _makeProductVariantAccessible(variantDomNode, variantType) {
        switch (variantType) {
        case optionsTypesMap.SET_RADIO:
        case optionsTypesMap.SWATCH: {
            initRadioOptions($(variantDomNode), '[type=radio]');
            break;
        }

        default: break;
        }
    }

    /**
     * Allow radio buttons to get deselected
     */
    initRadioAttributes() {
        $('[data-product-attribute] input[type="radio"]', this.$scope).each((i, radio) => {
            const $radio = $(radio);

            // Only bind to click once
            if ($radio.attr('data-state') !== undefined) {
                $radio.on('click', () => {
                    if ($radio.data('state') === true) {
                        $radio.prop('checked', false);
                        $radio.data('state', false);

                        $radio.trigger('change');
                    } else {
                        $radio.data('state', true);
                    }

                    this.initRadioAttributes();
                });
            }

            $radio.attr('data-state', $radio.prop('checked'));
        });
    }

    /**
     * Hide or mark as unavailable out of stock attributes if enabled
     * @param  {Object} data Product attribute data
     */
    updateProductAttributes(data) {
        const behavior = data.out_of_stock_behavior;
        const inStockIds = data.in_stock_attributes;
        const outOfStockMessage = ` (${data.out_of_stock_message})`;

        if (behavior !== 'hide_option' && behavior !== 'label_option') {
            return;
        }

        $('[data-product-attribute-value]', this.$scope).each((i, attribute) => {
            const $attribute = $(attribute);
            const attrId = parseInt($attribute.data('productAttributeValue'), 10);


            if (inStockIds.indexOf(attrId) !== -1) {
                this.enableAttribute($attribute, behavior, outOfStockMessage);
            } else {
                this.disableAttribute($attribute, behavior, outOfStockMessage);
            }
        });
    }

    /**
     * Check for fragment identifier in URL requesting a specific tab
     */
    getTabRequests() {
        if($(window).innerWidth() > 767) {
            if (window.location.hash && window.location.hash.indexOf('#tab-') === 0) {
                const $activeTab = $('.tabs').has(`[href='${window.location.hash}']`);
                const $tabContent = $(`${window.location.hash}`);

                if ($activeTab.length > 0) {
                    $activeTab.find('.tab')
                        .removeClass('is-active')
                        .has(`[href='${window.location.hash}']`)
                        .addClass('is-active');

                    $tabContent.addClass('is-active')
                        .siblings()
                        .removeClass('is-active');
                }
            } else {
                if($('.tabs .tab').length > 0) {
                    $('.tabs .tab:first-child, .tabs-contents .tab-content:first-child').addClass('is-active')
                }
            }
        }
        
    }
    /*
    * mobile pdp tab
    */
    mobileDetailTab() {
        if($(window).innerWidth() < 768) {
            $('.mobile-tab').click(function() {
                $(this).toggleClass('--active');
                $(this).next('section').toggleClass('is-active');
            })
        }
    }
    /**
    * create pdp description anchor
    */
    descAnchor() {
        var anchorHtml = '';
        var anchorTarget = $('#tab-product-info .pdp_desc .pdp-product-section-headline')
        if(anchorTarget.length > 0) {
            anchorTarget.each(function() {
                var anchorName = $(this).text();
                var anchorId = $(this).attr('id');
                //console.log($(this).text(), $(this).attr('id'));
                
                anchorHtml += `<a class="desc_anchor_point" href="#${anchorId}">${anchorName}</a>`
            })
            $('.pdp_desc_anchor .desc_anchors').html(anchorHtml);
        }else {
            $('.pdp_desc_anchor').hide();
            $('.pdp_desc').css("width", "100%")
        }
        
    }

    /**
    * scroll to anchor
    */
    scrollToAnchor() {
        var activeClass = '--current'
        $('.desc_anchor_point:first-child').addClass(activeClass);
        
        $(window).on('scroll', function() {
            var anchorTarget = $('#tab-product-info .pdp_desc .pdp-product-section-headline')
            anchorTarget.each(function() {
                var anchorId = $(this).attr('id');
                //console.log(anchorId)
                //console.log($(window).scrollTop(),$(this).offset().top - 220)
                if($(window).scrollTop() >= $(this).offset().top - 220) {
                    $('.desc_anchor_point').removeClass(activeClass);
                    $(`.desc_anchor_point[href="#${anchorId}"]`).addClass(activeClass);
                }
            })
        })

        $('.desc_anchor_point').on('click', function(e) {
            e.preventDefault();
            var anchorPoint = $(this).attr('href');
            //console.log(anchorPoint)
            $('html, body').animate({
                scrollTop: $(anchorPoint).offset().top - 30
            }, 300)
        })
        
    }
    
    /**
    * PDP sticky footer add to cart
    */
    stickyFooterAddToCart() {
        if (this.context.can_purchase) {
            var addToCartContainer = $('.pdp_stickyfooter_addtocart-container');

            var containerHeight = addToCartContainer.height() + 30;

            //add extra spacing for sticky footer
            $('.footer').css({
                "margin-bottom": `${containerHeight}px`
            });
            //create a fake add to qty
            //this is only trigger function for the qty and add to cart button from the normal addToCart & QTY
            $('.qty_input').val($('.form-input--incrementTotal').val());
            //increase item
            $('.add_item').click(function() {
                $('.form-increment .button--icon[data-action="inc"]').trigger('click');
                $('.qty_input').val($('.form-input--incrementTotal').val());
            })
            //decrease item
            $('.minus_item').click(function() {
                $('.form-increment .button--icon[data-action="dec"]').trigger('click');
                $('.qty_input').val($('.form-input--incrementTotal').val());
            })

            $('.form-increment .button--icon[data-action="dec"]').click(function() {
                if($('.form-input--incrementTotal').val() > 1 ) {
                    $('.qty_input').val(parseInt($('.form-input--incrementTotal').val()) - 1)
                }else {
                   $('.qty_input').val(parseInt($('.form-input--incrementTotal').val()))
                }
                
            })
            $('.form-increment .button--icon[data-action="inc"]').click(function() {
                //console.log(parseInt($('.form-input--incrementTotal').val()) + 1 )
                $('.qty_input').val(parseInt($('.form-input--incrementTotal').val()) + 1)
            })

            //add to cart
            $('.addToCart_action').click(function() {
                $('#form-action-addToCart').trigger('click')
            })

            //hide if regular add to cart is in viewport
            $(window).on('scroll', debounce(function() {
                var regularAddToCart = $('#form-action-addToCart');
                //console.log($(window).scrollTop(), 'vs', $(regularAddToCart).offset().top)
                if($(regularAddToCart).offset() && $(window).scrollTop() > $(regularAddToCart).offset().top + 50) {
                    $('.pdp_stickyfooter_addtocart-container').addClass('--visible')
                }else {
                    $('.pdp_stickyfooter_addtocart-container').removeClass('--visible')
                }
            }, 250))
        }
    }

    /**
    * pdp image thumb
    **/
    thumbSlide() {
        $('.productView-thumbnails').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1
                }
            }
            ]
        })
    }


    /**
    * pdp related & crossell 
    **/
    productCarousel() {
        console.log($('.productCarousel').length)
        $('.productCarousel').each(function() {
            $(this).slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 550,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            })

        })

        $('.productCarousel-slide').each(function(){
            $(this).css({
                "height": `${$(this).parentsUntil('.productCarousel').height()}px`
            })
        })
    }



    /**
     * Since $productView can be dynamically inserted using render_with,
     * We have to retrieve the respective elements
     *
     * @param $scope
     */
    getViewModel($scope) {
        return {
            $priceWithTax: $('[data-product-price-with-tax]', $scope),
            $priceWithoutTax: $('[data-product-price-without-tax]', $scope),
            rrpWithTax: {
                $div: $('.rrp-price--withTax', $scope),
                $span: $('[data-product-rrp-with-tax]', $scope),
            },
            rrpWithoutTax: {
                $div: $('.rrp-price--withoutTax', $scope),
                $span: $('[data-product-rrp-price-without-tax]', $scope),
            },
            nonSaleWithTax: {
                $div: $('.non-sale-price--withTax', $scope),
                $span: $('[data-product-non-sale-price-with-tax]', $scope),
            },
            nonSaleWithoutTax: {
                $div: $('.non-sale-price--withoutTax', $scope),
                $span: $('[data-product-non-sale-price-without-tax]', $scope),
            },
            priceSaved: {
                $div: $('.price-section--saving', $scope),
                $span: $('[data-product-price-saved]', $scope),
            },
            priceNowLabel: {
                $span: $('.price-now-label', $scope),
            },
            priceLabel: {
                $span: $('.price-label', $scope),
            },
            $weight: $('.productView-info [data-product-weight]', $scope),
            $increments: $('.form-field--increments :input', $scope),
            $addToCart: $('#form-action-addToCart', $scope),
            $wishlistVariation: $('[data-wishlist-add] [name="variation_id"]', $scope),
            stock: {
                $container: $('.form-field--stock', $scope),
                $input: $('[data-product-stock]', $scope),
            },
            sku: {
                $label: $('dt.sku-label', $scope),
                $value: $('[data-product-sku]', $scope),
            },
            upc: {
                $label: $('dt.upc-label', $scope),
                $value: $('[data-product-upc]', $scope),
            },
            quantity: {
                $text: $('.incrementTotal', $scope),
                $input: $('[name=qty\\[\\]]', $scope),
            },
            $bulkPricing: $('.productView-info-bulkPricing', $scope),
        };
    }

    /**
     * Hide the pricing elements that will show up only when the price exists in API
     * @param viewModel
     */
    clearPricingNotFound(viewModel) {
        viewModel.rrpWithTax.$div.hide();
        viewModel.rrpWithoutTax.$div.hide();
        viewModel.nonSaleWithTax.$div.hide();
        viewModel.nonSaleWithoutTax.$div.hide();
        viewModel.priceSaved.$div.hide();
        viewModel.priceNowLabel.$span.hide();
        viewModel.priceLabel.$span.hide();
    }

    /**
     * Update the view of price, messages, SKU and stock options when a product option changes
     * @param  {Object} data Product attribute data
     */
    updateView(data, content = null) {
        const viewModel = this.getViewModel(this.$scope);

        this.showMessageBox(data.stock_message || data.purchasing_message);

        if (isObject(data.price)) {
            this.updatePriceView(viewModel, data.price);
        }

        if (isObject(data.weight)) {
            viewModel.$weight.html(data.weight.formatted);
        }

        // Set variation_id if it exists for adding to wishlist
        if (data.variantId) {
            viewModel.$wishlistVariation.val(data.variantId);
        }

        // If SKU is available
        if (data.sku) {
            viewModel.sku.$value.text(data.sku);
            viewModel.sku.$label.show();
        } else {
            viewModel.sku.$label.hide();
            viewModel.sku.$value.text('');
        }

        // If UPC is available
        if (data.upc) {
            viewModel.upc.$value.text(data.upc);
            viewModel.upc.$label.show();
        } else {
            viewModel.upc.$label.hide();
            viewModel.upc.$value.text('');
        }

        // if stock view is on (CP settings)
        if (viewModel.stock.$container.length && isNumber(data.stock)) {
            // if the stock container is hidden, show
            viewModel.stock.$container.removeClass('u-hiddenVisually');

            viewModel.stock.$input.text(data.stock);
        } else {
            viewModel.stock.$container.addClass('u-hiddenVisually');
            viewModel.stock.$input.text(data.stock);
        }

        this.updateDefaultAttributesForOOS(data);

        // If Bulk Pricing rendered HTML is available
        if (data.bulk_discount_rates && content) {
            viewModel.$bulkPricing.html(content);
        } else if (typeof (data.bulk_discount_rates) !== 'undefined') {
            viewModel.$bulkPricing.html('');
        }

        const addToCartWrapper = $('#add-to-cart-wrapper');

        if (addToCartWrapper.is(':hidden') && data.purchasable) {
            addToCartWrapper.show();
        }
    }

    /**
     * Update the view of price, messages, SKU and stock options when a product option changes
     * @param  {Object} data Product attribute data
     */
    updatePriceView(viewModel, price) {
        this.clearPricingNotFound(viewModel);

        if (price.with_tax) {
            const updatedPrice = price.price_range ?
                `${price.price_range.min.with_tax.formatted} - ${price.price_range.max.with_tax.formatted}`
                : price.with_tax.formatted;
            viewModel.priceLabel.$span.show();
            viewModel.$priceWithTax.html(updatedPrice);
        }

        if (price.without_tax) {
            const updatedPrice = price.price_range ?
                `${price.price_range.min.without_tax.formatted} - ${price.price_range.max.without_tax.formatted}`
                : price.without_tax.formatted;
            viewModel.priceLabel.$span.show();
            viewModel.$priceWithoutTax.html(updatedPrice);
        }

        if (price.rrp_with_tax) {
            viewModel.rrpWithTax.$div.show();
            viewModel.rrpWithTax.$span.html(price.rrp_with_tax.formatted);
        }

        if (price.rrp_without_tax) {
            viewModel.rrpWithoutTax.$div.show();
            viewModel.rrpWithoutTax.$span.html(price.rrp_without_tax.formatted);
        }

        if (price.saved) {
            viewModel.priceSaved.$div.show();
            viewModel.priceSaved.$span.html(price.saved.formatted);
        }

        if (price.non_sale_price_with_tax) {
            viewModel.priceLabel.$span.hide();
            viewModel.nonSaleWithTax.$div.show();
            viewModel.priceNowLabel.$span.show();
            viewModel.nonSaleWithTax.$span.html(price.non_sale_price_with_tax.formatted);
        }

        if (price.non_sale_price_without_tax) {
            viewModel.priceLabel.$span.hide();
            viewModel.nonSaleWithoutTax.$div.show();
            viewModel.priceNowLabel.$span.show();
            viewModel.nonSaleWithoutTax.$span.html(price.non_sale_price_without_tax.formatted);
        }
    }

    /**
     * Show an message box if a message is passed
     * Hide the box if the message is empty
     * @param  {String} message
     */
    showMessageBox(message) {
        const $messageBox = $('.productAttributes-message');

        if (message) {
            $('.alertBox-message', $messageBox).text(message);
            $messageBox.show();
        } else {
            $messageBox.hide();
        }
    }

    updateDefaultAttributesForOOS(data) {
        const viewModel = this.getViewModel(this.$scope);
        if (!data.purchasable || !data.instock) {
            viewModel.$addToCart.prop('disabled', true);
            viewModel.$increments.prop('disabled', true);
        } else {
            viewModel.$addToCart.prop('disabled', false);
            viewModel.$increments.prop('disabled', false);
        }
    }

    enableAttribute($attribute, behavior, outOfStockMessage) {
        if (this.getAttributeType($attribute) === 'set-select') {
            return this.enableSelectOptionAttribute($attribute, behavior, outOfStockMessage);
        }

        if (behavior === 'hide_option') {
            $attribute.show();
        } else {
            $attribute.removeClass('unavailable');
        }
    }

    disableAttribute($attribute, behavior, outOfStockMessage) {
        if (this.getAttributeType($attribute) === 'set-select') {
            return this.disableSelectOptionAttribute($attribute, behavior, outOfStockMessage);
        }

        if (behavior === 'hide_option') {
            $attribute.hide(0);
        } else {
            $attribute.addClass('unavailable');
        }
    }

    getAttributeType($attribute) {
        const $parent = $attribute.closest('[data-product-attribute]');

        return $parent ? $parent.data('productAttribute') : null;
    }

    disableSelectOptionAttribute($attribute, behavior, outOfStockMessage) {
        const $select = $attribute.parent();

        if (behavior === 'hide_option') {
            $attribute.toggleOption(false);
            // If the attribute is the selected option in a select dropdown, select the first option (MERC-639)
            if ($select.val() === $attribute.attr('value')) {
                $select[0].selectedIndex = 0;
            }
        } else {
            $attribute.attr('disabled', 'disabled');
            $attribute.html($attribute.html().replace(outOfStockMessage, '') + outOfStockMessage);
        }
    }

    enableSelectOptionAttribute($attribute, behavior, outOfStockMessage) {
        if (behavior === 'hide_option') {
            $attribute.toggleOption(true);
        } else {
            $attribute.prop('disabled', false);
            $attribute.html($attribute.html().replace(outOfStockMessage, ''));
        }
    }
}
